/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * py-api
 * ML backend: FastAPI application
 * OpenAPI spec version: 0.0.1
 */
/**
 * URL to API documentation
 */
export type ApiInfoResponseDocsUrl = string | null;

/**
 * API information response model.
 */
export interface ApiInfoResponse {
  /** The API name */
  name: string;
  /** The API description */
  description: string;
  /** The API version */
  version: string;
  /** The API status */
  status?: string;
  /** URL to API documentation */
  docs_url?: ApiInfoResponseDocsUrl;
}

export interface BodyUploadModel {
  /** Human-readable name for this model version */
  model_name: string;
  /** Zip archive containing model_config.json (+ .ubj files for XGBoostLSS) */
  file: Blob;
  /** Whether this model is auto-selected when no model_id is given */
  is_default?: boolean;
}

export interface BodyUploadPlanningCsv {
  /** Planning CSV file to upload */
  file: Blob;
}

export interface BodyUploadYardCsv {
  /** Yard CSV file to upload */
  file: Blob;
}

export type ContainerFlow = (typeof ContainerFlow)[keyof typeof ContainerFlow];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContainerFlow = {
  IMPORT: 'IMPORT',
  EXPORT: 'EXPORT',
  TRANSSHIPMENT: 'TRANSSHIPMENT',
} as const;

export type ContainerType = (typeof ContainerType)[keyof typeof ContainerType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContainerType = {
  import: 'import',
  export: 'export',
  transshipment: 'transshipment',
} as const;

export interface CountData {
  simulation_run_id: string;
  data: CountPerShift[];
}

export type CountPerShiftRegular = { [key: string]: number };

export type CountPerShiftReefer = { [key: string]: number };

export interface CountPerShift {
  shift_datetime: string;
  regular: CountPerShiftRegular;
  reefer: CountPerShiftReefer;
}

export type EnrichmentStepTraceMethod =
  (typeof EnrichmentStepTraceMethod)[keyof typeof EnrichmentStepTraceMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichmentStepTraceMethod = {
  extrapolated: 'extrapolated',
  predicted: 'predicted',
} as const;

export type EnrichmentStepTraceValues = { [key: string]: number };

export type EnrichmentStepTraceFeaturesAnyOf = {
  [key: string]: { [key: string]: unknown };
};

export type EnrichmentStepTraceFeatures =
  EnrichmentStepTraceFeaturesAnyOf | null;

/**
 * Provenance for one direction (unload or load) of a single ship visit's enrichment.
 */
export interface EnrichmentStepTrace {
  method: EnrichmentStepTraceMethod;
  values: EnrichmentStepTraceValues;
  features?: EnrichmentStepTraceFeatures;
}

export interface ExplicitTransshipmentTransfer {
  /** @minLength 1 */
  source_ship_visit_id: string;
  /** @minLength 1 */
  target_ship_visit_id: string;
  /**
   * Minimum total for this source/target pair, including matching containers already on the yard. Must not exceed 5000.
   * @maximum 5000
   */
  n_containers: number;
}

/**
 * These containers come from a truck / inland vessel and will be loaded onto a ship.
 */
export interface ExportContainerData {
  id: string;
  arrival_time: string;
  reefer: boolean;
  TEU: number;
  outbound_mode: TransportMode;
  inbound_mode: TransportMode;
  destination_ship_visit: ShipVisitData;
  departure_time: string;
  readonly dwell_time: string;
}

export interface HTTPValidationError {
  detail?: ValidationError[];
}

export type HealthCheckResponseStatus =
  (typeof HealthCheckResponseStatus)[keyof typeof HealthCheckResponseStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HealthCheckResponseStatus = {
  healthy: 'healthy',
  unhealthy: 'unhealthy',
} as const;

/**
 * Health check response model.
 */
export interface HealthCheckResponse {
  status?: HealthCheckResponseStatus;
}

/**
 * These containers will be loaded onto a truck / inland vessel.
 */
export interface ImportContainerData {
  id: string;
  arrival_time: string;
  reefer: boolean;
  TEU: number;
  outbound_mode: TransportMode;
  inbound_mode: TransportMode;
  origin_ship_visit_id: string;
  dwell_time: string;
  readonly departure_time: string;
}

/**
 * Response model for listing ML model uploads.
 */
export interface ModelListResponse {
  /** List of model uploads */
  items: ModelUploadResponse[];
  /** Total number of models matching the filter */
  total: number;
  /** Number of items skipped */
  skip: number;
  /** Maximum number of items returned */
  limit: number;
}

/**
 * New human-readable name for this model version
 */
export type ModelUpdateRequestModelName = string | null;

/**
 * Whether this model should be auto-selected when no model_id is given
 */
export type ModelUpdateRequestIsDefault = boolean | null;

/**
 * Request body for updating an existing ML model.
 */
export interface ModelUpdateRequest {
  /** New human-readable name for this model version */
  model_name?: ModelUpdateRequestModelName;
  /** Whether this model should be auto-selected when no model_id is given */
  is_default?: ModelUpdateRequestIsDefault;
}

/**
 * Response model for ML model upload (excludes zip content).
 */
export interface ModelUploadResponse {
  /** Unique identifier for the model upload */
  id: string;
  /** Whether this model is auto-selected when no model_id is given */
  is_default?: boolean;
  /** Human-readable name for the model */
  model_name: string;
  /** Timestamp when the model was uploaded */
  upload_timestamp?: string;
  /** Number of recent historic visits used as lag features */
  n_recent_visits?: number;
}

export type OccupancyDataHighlighed = boolean | null;

export interface OccupancyData {
  simulation_run_id: string;
  data: OccupancyPerShift[];
  highlighed?: OccupancyDataHighlighed;
}

export interface OccupancyPerShift {
  shift_datetime: string;
  regular: number;
  reefer: number;
}

export type PlanningCreateRequestUploadTimestamp = string | null;

/**
 * Original filename of the uploaded CSV
 */
export type PlanningCreateRequestFilename = string | null;

export type PlanningCreateRequestIsGroundTruth = boolean | null;

export interface PlanningCreateRequest {
  id: string;
  /** List of ship visits in the planning */
  ship_visits?: RawShipVisitDataInput[];
  upload_timestamp?: PlanningCreateRequestUploadTimestamp;
  /** Original filename of the uploaded CSV */
  filename?: PlanningCreateRequestFilename;
  is_ground_truth?: PlanningCreateRequestIsGroundTruth;
}

export type PlanningDataInputId = string | null;

export type PlanningDataInputUploadTimestamp = string | null;

/**
 * Original filename of the uploaded CSV
 */
export type PlanningDataInputFilename = string | null;

export type PlanningDataInputIsGroundTruth = boolean | null;

/**
 * Planning data model for JSON validation.

DATABASE_FIELDS are persisted in PostgreSQL (id, upload_timestamp, filename, is_ground_truth).
BLOB_FIELDS are persisted in blob storage (ship_visits).
ship_visits is an empty list when the record is retrieved without blob content.
 */
export interface PlanningDataInput {
  id?: PlanningDataInputId;
  /** List of ship visits in the planning */
  ship_visits?: RawShipVisitDataInput[];
  upload_timestamp?: PlanningDataInputUploadTimestamp;
  /** Original filename of the uploaded CSV */
  filename?: PlanningDataInputFilename;
  is_ground_truth?: PlanningDataInputIsGroundTruth;
}

export type PlanningDataOutputId = string | null;

export type PlanningDataOutputUploadTimestamp = string | null;

/**
 * Original filename of the uploaded CSV
 */
export type PlanningDataOutputFilename = string | null;

export type PlanningDataOutputIsGroundTruth = boolean | null;

/**
 * Planning data model for JSON validation.

DATABASE_FIELDS are persisted in PostgreSQL (id, upload_timestamp, filename, is_ground_truth).
BLOB_FIELDS are persisted in blob storage (ship_visits).
ship_visits is an empty list when the record is retrieved without blob content.
 */
export interface PlanningDataOutput {
  id?: PlanningDataOutputId;
  /** List of ship visits in the planning */
  ship_visits?: RawShipVisitDataOutput[];
  upload_timestamp?: PlanningDataOutputUploadTimestamp;
  /** Original filename of the uploaded CSV */
  filename?: PlanningDataOutputFilename;
  is_ground_truth?: PlanningDataOutputIsGroundTruth;
}

/**
 * Response model for listing plannings.
 */
export interface PlanningListResponse {
  /** List of plannings */
  items: PlanningDataOutput[];
  /** Total number of plannings matching the filter */
  total: number;
  /** Number of items skipped */
  skip: number;
  /** Maximum number of items returned */
  limit: number;
}

export type RawShipVisitDataInputOperatorId = string | null;

export type RawShipVisitDataInputDepartureTime = string | null;

export type RawShipVisitDataInputStartWorkTime = string | null;

export type RawShipVisitDataInputEndWorkTime = string | null;

export type RawShipVisitDataInputNMovesLoad = number | null;

export type RawShipVisitDataInputNMovesDischarge = number | null;

export type RawShipVisitDataInputNRegularExportContainers = number | null;

export type RawShipVisitDataInputNReeferExportContainers = number | null;

export type RawShipVisitDataInputNRegularTransshipmentContainers =
  | number
  | null;

export type RawShipVisitDataInputNReeferTransshipmentContainers = number | null;

export type RawShipVisitDataInputNRegularImportContainers = number | null;

export type RawShipVisitDataInputNReeferImportContainers = number | null;

export type RawShipVisitDataInputBollardFore = number | null;

export type RawShipVisitDataInputBollardAft = number | null;

/**
 * Raw ship visit data model for JSON validation.
 */
export interface RawShipVisitDataInput {
  id: string;
  ship_id: string;
  shipping_line_id: string;
  arrival_time: string;
  operator_id?: RawShipVisitDataInputOperatorId;
  departure_time?: RawShipVisitDataInputDepartureTime;
  start_work_time?: RawShipVisitDataInputStartWorkTime;
  end_work_time?: RawShipVisitDataInputEndWorkTime;
  n_moves_load?: RawShipVisitDataInputNMovesLoad;
  n_moves_discharge?: RawShipVisitDataInputNMovesDischarge;
  n_regular_export_containers?: RawShipVisitDataInputNRegularExportContainers;
  n_reefer_export_containers?: RawShipVisitDataInputNReeferExportContainers;
  n_regular_transshipment_containers?: RawShipVisitDataInputNRegularTransshipmentContainers;
  n_reefer_transshipment_containers?: RawShipVisitDataInputNReeferTransshipmentContainers;
  n_regular_import_containers?: RawShipVisitDataInputNRegularImportContainers;
  n_reefer_import_containers?: RawShipVisitDataInputNReeferImportContainers;
  bollard_fore?: RawShipVisitDataInputBollardFore;
  bollard_aft?: RawShipVisitDataInputBollardAft;
  historic?: boolean;
}

export type RawShipVisitDataOutputOperatorId = string | null;

export type RawShipVisitDataOutputDepartureTime = string | null;

export type RawShipVisitDataOutputStartWorkTime = string | null;

export type RawShipVisitDataOutputEndWorkTime = string | null;

export type RawShipVisitDataOutputNMovesLoad = number | null;

export type RawShipVisitDataOutputNMovesDischarge = number | null;

export type RawShipVisitDataOutputNRegularExportContainers = number | null;

export type RawShipVisitDataOutputNReeferExportContainers = number | null;

export type RawShipVisitDataOutputNRegularTransshipmentContainers =
  | number
  | null;

export type RawShipVisitDataOutputNReeferTransshipmentContainers =
  | number
  | null;

export type RawShipVisitDataOutputNRegularImportContainers = number | null;

export type RawShipVisitDataOutputNReeferImportContainers = number | null;

export type RawShipVisitDataOutputBollardFore = number | null;

export type RawShipVisitDataOutputBollardAft = number | null;

export type RawShipVisitDataOutputBerthPositionStartMeter = number | null;

export type RawShipVisitDataOutputBerthPositionEndMeter = number | null;

export type RawShipVisitDataOutputBerthLengthMeter = number | null;

/**
 * Raw ship visit data model for JSON validation.
 */
export interface RawShipVisitDataOutput {
  id: string;
  ship_id: string;
  shipping_line_id: string;
  arrival_time: string;
  operator_id?: RawShipVisitDataOutputOperatorId;
  departure_time?: RawShipVisitDataOutputDepartureTime;
  start_work_time?: RawShipVisitDataOutputStartWorkTime;
  end_work_time?: RawShipVisitDataOutputEndWorkTime;
  n_moves_load?: RawShipVisitDataOutputNMovesLoad;
  n_moves_discharge?: RawShipVisitDataOutputNMovesDischarge;
  n_regular_export_containers?: RawShipVisitDataOutputNRegularExportContainers;
  n_reefer_export_containers?: RawShipVisitDataOutputNReeferExportContainers;
  n_regular_transshipment_containers?: RawShipVisitDataOutputNRegularTransshipmentContainers;
  n_reefer_transshipment_containers?: RawShipVisitDataOutputNReeferTransshipmentContainers;
  n_regular_import_containers?: RawShipVisitDataOutputNRegularImportContainers;
  n_reefer_import_containers?: RawShipVisitDataOutputNReeferImportContainers;
  bollard_fore?: RawShipVisitDataOutputBollardFore;
  bollard_aft?: RawShipVisitDataOutputBollardAft;
  historic?: boolean;
  readonly berth_position_start_meter: RawShipVisitDataOutputBerthPositionStartMeter;
  readonly berth_position_end_meter: RawShipVisitDataOutputBerthPositionEndMeter;
  readonly berth_length_meter: RawShipVisitDataOutputBerthLengthMeter;
}

/**
 * Regular/reefer counts describe only NEW containers still to discharge.
 */
export interface ResolvedTransshipmentTransfer {
  /** @minLength 1 */
  source_ship_visit_id: string;
  /** @minLength 1 */
  target_ship_visit_id: string;
  /**
   * Minimum total for this source/target pair, including matching containers already on the yard. Must not exceed 5000.
   * @maximum 5000
   */
  n_containers: number;
  /** @minimum 0 */
  n_already_on_yard: number;
  /** @minimum 0 */
  n_regular_containers: number;
  /** @minimum 0 */
  n_reefer_containers: number;
}

/**
 * Start time of the simulation
 */
export type ScenarioCreateRequestStartTime = string | null;

/**
 * ID of the ML model to use for ship visit prediction; defaults to the model configured as default, or the most recently uploaded model otherwise
 */
export type ScenarioCreateRequestModelId = string | null;

export type ScenarioCreateRequestYardPropertiesId = string | null;

/**
 * Human-readable name of the scenario
 */
export type ScenarioCreateRequestName = string | null;

/**
 * Request model for creating a simulation.
 */
export interface ScenarioCreateRequest {
  /** Minimum source/target transshipment totals, including matching on-yard containers. */
  explicit_transshipment_transfers?: ExplicitTransshipmentTransfer[];
  /** ID of the planning to use */
  planning_id: string;
  /** ID of the yard to use */
  yard_id: string;
  /** Number of simulation runs to run */
  total_simulation_runs?: number;
  /** Start time of the simulation */
  start_time?: ScenarioCreateRequestStartTime;
  /**
   * Number of days to simulate
   */
  duration_days?: number;
  /** ID of the ML model to use for ship visit prediction; defaults to the model configured as default, or the most recently uploaded model otherwise */
  model_id?: ScenarioCreateRequestModelId;
  yard_properties_id?: ScenarioCreateRequestYardPropertiesId;
  /** Human-readable name of the scenario */
  name?: ScenarioCreateRequestName;
}

/**
 * Response model for listing all scenario results.
 */
export interface ScenarioDataResponse {
  scenario_id: string;
  total_simulation_runs: number;
  completed_simulation_runs: number;
  simulation_runs: SimulationRunData[];
}

/**
 * Response model for listing simulations.
 */
export interface ScenarioListResponse {
  /** List of scenarios */
  items: ScenarioResponse[];
  /** Total number of simulations matching the filter */
  total: number;
  /** Number of items skipped */
  skip: number;
  /** Maximum number of items returned */
  limit: number;
}

export interface ScenarioOccupancyData {
  scenario_id: string;
  runs: OccupancyData[];
}

/**
 * Allowed sort fields when listing scenarios.
 */
export type ScenarioOrderBy =
  (typeof ScenarioOrderBy)[keyof typeof ScenarioOrderBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScenarioOrderBy = {
  creation_date: 'creation_date',
  progress: 'progress',
  total_simulation_runs: 'total_simulation_runs',
  completed_simulation_runs: 'completed_simulation_runs',
} as const;

export type ScenarioResponseCreationDate = string | null;

/**
 * Start time of the simulation
 */
export type ScenarioResponseStartTime = string | null;

export type ScenarioResponseCompletedSimulationRuns = number | null;

/**
 * Progress as a percentage (0.0 to 1.0)
 */
export type ScenarioResponseProgress = number | null;

/**
 * ID of the ML model used for ship visit prediction (None = default fixtures)
 */
export type ScenarioResponseModelId = string | null;

export type ScenarioResponseYardPropertiesId = string | null;

/**
 * Human-readable name of the scenario
 */
export type ScenarioResponseName = string | null;

/**
 * Response model for Simulation metadata.

DATABASE_FIELDS are persisted in PostgreSQL (all fields).
BLOB_FIELDS is empty — no blob storage used for scenarios.
 */
export interface ScenarioResponse {
  id: string;
  /** Minimum source/target transshipment totals, including matching on-yard containers. */
  explicit_transshipment_transfers?: ExplicitTransshipmentTransfer[];
  creation_date?: ScenarioResponseCreationDate;
  planning_id: string;
  yard_id: string;
  total_simulation_runs: number;
  /** Start time of the simulation */
  start_time?: ScenarioResponseStartTime;
  /** Number of days simulated */
  duration_days: number;
  completed_simulation_runs?: ScenarioResponseCompletedSimulationRuns;
  simulation_runs?: string[];
  /** Progress as a percentage (0.0 to 1.0) */
  progress?: ScenarioResponseProgress;
  /** ID of the ML model used for ship visit prediction (None = default fixtures) */
  model_id?: ScenarioResponseModelId;
  yard_properties_id?: ScenarioResponseYardPropertiesId;
  /** Human-readable name of the scenario */
  name?: ScenarioResponseName;
}

/**
 * Human-readable name of the scenario
 */
export type ScenarioUpdateRequestName = string | null;

/**
 * Request model for updating a scenario's editable fields.
 */
export interface ScenarioUpdateRequest {
  /** Human-readable name of the scenario */
  name: ScenarioUpdateRequestName;
}

/**
 * Ship visit data model for JSON validation.
 */
export interface ShipVisitData {
  id: string;
  ship_id: string;
  shipping_line_id: string;
  operator_id: string;
  arrival_time: string;
  departure_time: string;
  n_regular_import_containers: number;
  n_reefer_import_containers: number;
  n_regular_transshipment_containers: number;
  n_reefer_transshipment_containers: number;
  n_regular_export_containers: number;
  n_reefer_export_containers: number;
}

/**
 * Planning model.
 */
export interface ShipVisitPlanningData {
  id: string;
  ship_visits: AppDataEndpointModelsPlanningShipVisitData[];
  created_at: string;
  modified_at: string;
}

/**
 * Provenance for a single ship visit's enrichment.
 */
export interface ShipVisitTrace {
  id: string;
  ship_id: string;
  shipping_line_id: string;
  arrival_time: string;
  unload: EnrichmentStepTrace;
  load: EnrichmentStepTrace;
}

export type SimulationRunDataYardPropertiesId = string | null;

export type SimulationRunDataExportContainers = {
  [key: string]: ExportContainerData;
};

export type SimulationRunDataTransshipmentContainers = {
  [key: string]: TransshipmentContainerData;
};

/**
 * Yard configuration data model for JSON validation.
 */
export interface SimulationRunData {
  id: string;
  scenario_id: string;
  yard_properties_id?: SimulationRunDataYardPropertiesId;
  teu_capacity: number;
  n_reefer_capacity: number;
  import_containers: ImportContainerData[];
  export_containers: SimulationRunDataExportContainers;
  transshipment_containers: SimulationRunDataTransshipmentContainers;
  states: YardStateData[];
  /** Vessel names that were not found in the TEU lookup dataset during prediction enrichment. Stored so the dataset can be expanded over time. */
  missing_teu_vessels?: string[];
}

export type SimulationTraceShipVisitTraces = { [key: string]: ShipVisitTrace };

/**
 * Provenance for every ship visit enriched while preparing a simulation run.
 */
export interface SimulationTrace {
  ship_visit_traces: SimulationTraceShipVisitTraces;
  explicit_transshipment_transfers?: ResolvedTransshipmentTransfer[];
  transshipment_count_adjustments?: TransshipmentCountAdjustment[];
}

/**
 * Per-ship-visit enrichment provenance for a single simulation run.

Stored via the standard ``StorageBackend[SimulationTraceData]`` abstraction,
same as ``ContainerHistoryData`` — no DB row / migration required.
 */
export interface SimulationTraceData {
  /** Simulation run ID this trace belongs to */
  id: string;
  /** Timestamp when the trace was written */
  upload_timestamp?: string;
  /** Per-ship-visit enrichment provenance */
  trace: SimulationTrace;
}

export interface TeuData {
  simulation_run_id: string;
  data: TeuPerShift[];
}

export interface TeuPerShift {
  shift_datetime: string;
  import_containers: number;
  export_containers: number;
  transshipment_containers: number;
}

export type TransportMode = (typeof TransportMode)[keyof typeof TransportMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransportMode = {
  TRUCK: 'TRUCK',
  VESSEL: 'VESSEL',
  TRAIN: 'TRAIN',
} as const;

/**
 * These containers come from a ship and will be loaded onto another ship.
 */
export interface TransshipmentContainerData {
  id: string;
  arrival_time: string;
  reefer: boolean;
  TEU: number;
  outbound_mode: TransportMode;
  inbound_mode: TransportMode;
  origin_ship_visit_id: string;
  destination_ship_visit: ShipVisitData;
  departure_time: string;
  readonly dwell_time: string;
}

export interface TransshipmentCountAdjustment {
  ship_visit_id: string;
  field_name: string;
  baseline_value: number;
  final_value: number;
  on_yard_count: number;
  explicit_requirement: number;
}

export type ValidationErrorLocItem = string | number;

export interface ValidationError {
  loc: ValidationErrorLocItem[];
  msg: string;
  type: string;
}

export type YardDirection = (typeof YardDirection)[keyof typeof YardDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const YardDirection = {
  IN: 'IN',
  OUT: 'OUT',
} as const;

/**
 * Response model for listing yard uploads.
 */
export interface YardListResponse {
  /** List of yard uploads */
  items: YardUploadResponse[];
  /** Total number of yard uploads matching the filter */
  total: number;
  /** Number of items skipped */
  skip: number;
  /** Maximum number of items returned */
  limit: number;
}

export type YardMoveCategory =
  (typeof YardMoveCategory)[keyof typeof YardMoveCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const YardMoveCategory = {
  LANDSIDE: 'LANDSIDE',
  WATERSIDE_BARGE: 'WATERSIDE_BARGE',
  WATERSIDE_DEEPSEA_FEEDER: 'WATERSIDE_DEEPSEA_FEEDER',
} as const;

export type YardMoveTransportMode =
  (typeof YardMoveTransportMode)[keyof typeof YardMoveTransportMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const YardMoveTransportMode = {
  TRUCK: 'TRUCK',
  TRAIN: 'TRAIN',
  BARGE: 'BARGE',
  VESSEL: 'VESSEL',
} as const;

export interface YardMovement {
  shift_id: string;
  category: YardMoveCategory;
  /** Transport mode of the move; hinterland moves by vessel are reported as barge. */
  transport_mode: YardMoveTransportMode;
  /** Whether the move adds containers to the yard or removes them from it. */
  yard_direction: YardDirection;
  container_flow: ContainerFlow;
  /** @minimum 1 */
  container_count: number;
  /** Ship visit whose color is used for this bar segment. For barge moves this is the deep-sea or feeder visit the container connects to, as the barge itself is not identified. */
  display_ship_visit_id: string;
  /**
   * Ship visits this movement matches when filtering; origin and destination for transshipment.
   * @minItems 1
   */
  related_ship_visit_ids: string[];
}

export interface YardMovesResponse {
  run_id: string;
  timezone?: string;
  shift_duration_hours?: number;
  ship_visits: YardMovesShipVisit[];
  shifts: YardMovesShift[];
  movements: YardMovement[];
}

export interface YardMovesShift {
  id: string;
  start_time: string;
  end_time: string;
}

/**
 * Vessel name from the run's ship visit planning.
 */
export type YardMovesShipVisitVesselName = string | null;

export interface YardMovesShipVisit {
  id: string;
  /** Vessel name from the run's ship visit planning. */
  vessel_name?: YardMovesShipVisitVesselName;
}

/**
 * Request body for creating a new yard properties configuration.

The new configuration always becomes the default.
 */
export interface YardPropertiesCreateRequest {
  /** */
  teu_capacity: number;
  /** */
  n_reefer_capacity: number;
  name: string;
}

/**
 * Response model for listing yard properties configurations.
 */
export interface YardPropertiesListResponse {
  items: YardPropertiesResponse[];
  total: number;
  skip: number;
  limit: number;
}

/**
 * Response model for a yard properties configuration.
 */
export interface YardPropertiesResponse {
  id: string;
  is_default?: boolean;
  teu_capacity: number;
  n_reefer_capacity: number;
  name: string;
  created_at?: string;
}

export type YardStateDataContainerAgeDistribution = { [key: string]: number };

/**
 * Yard state model.
 */
export interface YardStateData {
  time: string;
  n_total_containers: number;
  total_teu: number;
  occupancy_percentage: number;
  occupancy_percentage_reefer: number;
  n_total_regular_containers: number;
  n_total_reefer_containers: number;
  n_regular_import_containers: number;
  n_reefer_import_containers: number;
  n_regular_transshipment_containers: number;
  n_reefer_transshipment_containers: number;
  n_regular_export_containers: number;
  n_reefer_export_containers: number;
  teu_regular_import_containers: number;
  teu_reefer_import_containers: number;
  teu_regular_transshipment_containers: number;
  teu_reefer_transshipment_containers: number;
  teu_regular_export_containers: number;
  teu_reefer_export_containers: number;
  container_age_distribution: YardStateDataContainerAgeDistribution;
}

/**
 * Latest container time in found in the yard CSV (UTC), used to suggest a simulation start
 */
export type YardUploadLastTimeIn = string | null;

/**
 * Content of the uploaded file
 */
export type YardUploadFileContent = Blob | null;

/**
 * Model for Yard upload.

DATABASE_FIELDS are persisted in PostgreSQL (id, upload_timestamp, filename, file_size, last_time_in).
BLOB_FIELDS are persisted in blob storage (file_content).
file_content is None when the record is retrieved without blob content (e.g. listing).
 */
export interface YardUpload {
  /** Unique identifier for the yard upload */
  id: string;
  /** Timestamp when the yard CSV was uploaded */
  upload_timestamp?: string;
  /** Original filename of the uploaded CSV */
  filename: string;
  /** Size of the uploaded file in bytes */
  file_size: number;
  /** Latest container time in found in the yard CSV (UTC), used to suggest a simulation start */
  last_time_in?: YardUploadLastTimeIn;
  /** Content of the uploaded file */
  file_content?: YardUploadFileContent;
}

/**
 * Latest container time in found in the yard CSV (UTC), used to suggest a simulation start
 */
export type YardUploadResponseLastTimeIn = string | null;

/**
 * Response model for Yard upload response (excludes file content).
 */
export interface YardUploadResponse {
  /** Unique identifier for the yard upload */
  id: string;
  /** Timestamp when the yard CSV was uploaded */
  upload_timestamp?: string;
  /** Original filename of the uploaded CSV */
  filename: string;
  /** Size of the uploaded file in bytes */
  file_size: number;
  /** Latest container time in found in the yard CSV (UTC), used to suggest a simulation start */
  last_time_in?: YardUploadResponseLastTimeIn;
}

/**
 * Start bollard number of the berth position. Distance between 2 bollards = 20m
 */
export type AppDataEndpointModelsPlanningShipVisitDataBollardFore =
  | number
  | null;

/**
 * End bollard number of the berth position. Distance between 2 bollards = 20m
 */
export type AppDataEndpointModelsPlanningShipVisitDataBollardAft =
  | number
  | null;

/**
 * How the import/transshipment counts were obtained.
 */
export type AppDataEndpointModelsPlanningShipVisitDataUnloadSource =
  | 'extrapolated'
  | 'predicted'
  | null;

/**
 * How the export counts were obtained.
 */
export type AppDataEndpointModelsPlanningShipVisitDataLoadSource =
  | 'extrapolated'
  | 'predicted'
  | null;

export type AppDataEndpointModelsPlanningShipVisitDataBerthPositionStartMeter =
  | number
  | null;

export type AppDataEndpointModelsPlanningShipVisitDataBerthPositionEndMeter =
  | number
  | null;

export type AppDataEndpointModelsPlanningShipVisitDataBerthLengthMeter =
  | number
  | null;

/**
 * Ship visit model.
 */
export interface AppDataEndpointModelsPlanningShipVisitData {
  id: string;
  ship_id: string;
  shipping_line_id: string;
  arrival_time: string;
  operator_id: string;
  departure_time: string;
  start_work_time: string;
  end_work_time: string;
  n_moves_load: number;
  n_moves_discharge: number;
  n_regular_import_containers: number;
  n_reefer_import_containers: number;
  n_regular_transshipment_containers: number;
  n_reefer_transshipment_containers: number;
  n_regular_export_containers: number;
  n_reefer_export_containers: number;
  /** Start bollard number of the berth position. Distance between 2 bollards = 20m */
  bollard_fore?: AppDataEndpointModelsPlanningShipVisitDataBollardFore;
  /** End bollard number of the berth position. Distance between 2 bollards = 20m */
  bollard_aft?: AppDataEndpointModelsPlanningShipVisitDataBollardAft;
  /** How the import/transshipment counts were obtained. */
  unload_source?: AppDataEndpointModelsPlanningShipVisitDataUnloadSource;
  /** How the export counts were obtained. */
  load_source?: AppDataEndpointModelsPlanningShipVisitDataLoadSource;
  readonly berth_position_start_meter: AppDataEndpointModelsPlanningShipVisitDataBerthPositionStartMeter;
  readonly berth_position_end_meter: AppDataEndpointModelsPlanningShipVisitDataBerthPositionEndMeter;
  readonly berth_length_meter: AppDataEndpointModelsPlanningShipVisitDataBerthLengthMeter;
}

export type GetYardsParams = {
  /**
   * Filter uploads from this date (inclusive). ISO format: YYYY-MM-DDTHH:MM:SS
   */
  start_date?: string | null;
  /**
   * Filter uploads until this date (inclusive). ISO format: YYYY-MM-DDTHH:MM:SS
   */
  end_date?: string | null;
  /**
   * Number of items to skip
   * @minimum 0
   */
  skip?: number;
  /**
   * Maximum number of items to return
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
};

export type ListYardPropertiesParams = {
  /**
   * Number of items to skip
   * @minimum 0
   */
  skip?: number;
  /**
   * Maximum number of items to return
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
};

export type GetPlanningParams = {
  /**
   * Include historic ship visits (Phase=70CLOSED/50COMPLETE). Defaults to False.
   */
  include_historic?: boolean | null;
};

export type GetPlanningsParams = {
  /**
   * Filter uploads from this date (inclusive). ISO format: YYYY-MM-DDTHH:MM:SS
   */
  start_date?: string | null;
  /**
   * Filter uploads until this date (inclusive). ISO format: YYYY-MM-DDTHH:MM:SS
   */
  end_date?: string | null;
  /**
   * Filter by ground truth status. Defaults to True (only ground-truth plannings). Set to False for simulated drafts, or None for all plannings.
   */
  is_ground_truth?: boolean | null;
  /**
   * Include historic ship visits (Phase=70CLOSED/50COMPLETE). Defaults to False.
   */
  include_historic?: boolean | null;
  /**
   * Number of items to skip
   * @minimum 0
   */
  skip?: number;
  /**
   * Maximum number of items to return
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
};

export type ListModelsParams = {
  /**
   * Number of items to skip
   * @minimum 0
   */
  skip?: number;
  /**
   * Maximum number of items to return
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
};

export type GetScenariosParams = {
  /**
   * Filter uploads from this date (inclusive). ISO format: YYYY-MM-DDTHH:MM:SS
   */
  start_date?: string | null;
  /**
   * Filter uploads until this date (inclusive). ISO format: YYYY-MM-DDTHH:MM:SS
   */
  end_date?: string | null;
  /**
   * Number of items to skip
   * @minimum 0
   */
  skip?: number;
  /**
   * Maximum number of items to return
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  /**
   * Field to sort scenarios by before applying skip and limit.
   */
  order_by?: ScenarioOrderBy;
  /**
   * Sort descending when true. Defaults to newest-first for creation_date.
   */
  descending?: boolean;
  /**
   * Case-insensitive substring of the scenario name. Unnamed scenarios are excluded.
   */
  name?: string | null;
};

export type GetSimulationRunContainerHistoryParams = {
  format: GetSimulationRunContainerHistoryFormat;
};

export type GetSimulationRunContainerHistoryFormat =
  (typeof GetSimulationRunContainerHistoryFormat)[keyof typeof GetSimulationRunContainerHistoryFormat];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSimulationRunContainerHistoryFormat = {
  csv: 'csv',
  excel: 'excel',
} as const;
